import React,{Component} from 'react';
import { connect } from 'react-redux';
import $ from'jquery';
import {
    Card,
  } from "tabler-react";
import TextTruncate from 'react-text-truncate';
// import  './Ticker.js';
// import  './style.css';

class TickerComponent extends Component {
    componentDidMount()
    {
        $(function(){
            $(window).on('load',function(){
                  // $('.demof > ul > li:nth-child(2)').hide();
                  $('.demof > ul > li').not(":first-child").hide();
            })
            $(document).ready(function(){
                  // $('.demof > ul > li:nth-child(2)').hide();
                  $('.demof > ul > li').children().show();
            })
            $('.ticker').easyTicker({
                direction: 'up',
                visible: 1,
                easing: 'easeOutBounce',
                interval: 2500
            });
        });
    }
    render()
    {
        const {tickerData} = this.props;
     //check if reloaded once already 
        if((Array.isArray(tickerData) && tickerData.length > 0))
        {
            return (
                <Card.Options className="map-ticker">
                 <div className="ticker demof">
                        <ul>
                            {tickerData && tickerData.map((data,i) =>
                                <li key={i}>
                                <div className="tickerImage">
                                    <img src={data.image} alt={data.ticker_heading} />
                                </div>
                                <TextTruncate
                                    line={2}
                                    element="h3"
                                    truncateText="…"
                                    text={data.ticker_heading}
                                />
                                        {/* <h3>{data.ticker_heading}</h3> */}
                                <TextTruncate
                                    line={2}
                                    element="p"
                                    truncateText="…"
                                    text={data.synopsis}
                                />
                                <a href={data.url} target="_blank" rel="noopener noreferrer">See More</a>
                                </li>
                            )}
                        </ul>
                    </div>
                </Card.Options>
            );
        }else{
            return true;
        }
    }
    componentWillReceiveProps()
    {
        $('.ticker').easyTicker({
            direction: 'up',
            visible: 1,
            easing: 'easeOutBounce',
            interval: 2500
        });
    }
}

function mapStateToProps(state) {
    const { tickerData } = state.ticker;
    return {
       tickerData
    };
}

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TickerComponent);